"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRefinanaceOutputToResult = exports.transformAffordabilityOutputToResult = exports.transformMortgageMonthlyOutputToResult = exports.transformError = void 0;
var MortgageCommonError_1 = require("@/pages/mortagage/states/MortgageCommonError");
var MortgageError_1 = require("@okay/okay-mortgage/src/states/MortgageError");
exports.transformError = function (error) {
    if (error.type === MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_PERCENT_AMOUNT) {
        return new MortgageCommonError_1.MortgageTooMuchLoanPercentError(error.maxLoanPercent);
    }
    if (error.type === MortgageError_1.MortgageErrorType.EXCEED_MORTGAGE_FIX_AMOUNT) {
        return new MortgageCommonError_1.MortgageTooMuchLoanAmountError(error.maxLoanAmount);
    }
    if (error.type === MortgageError_1.MortgageErrorType.TENOR_OVER) {
        return new MortgageCommonError_1.MortgageExceedTenorError(error.maxTenor);
    }
    return new MortgageCommonError_1.MortgageCommonError();
};
exports.transformMortgageMonthlyOutputToResult = function (output) {
    return {
        monthlyPayment: output.monthlyPayment,
        totalExpenses: output.totalExpenses,
        totalCashOutlay: output.totalCashOutlay,
        totalInterest: output.totalInterest,
        totalTax: output.totalTax,
        commission: output.commission,
        schedule: output.schedule,
        rateTable: output.rateTable,
        insurance: output.insurance,
        insuranceInitial: output.insuranceInitial,
        loanAmount: output.loanAmount,
        minimumIncome: 0,
        assumedInterestRate: 0,
        legalAmount: output.legalAmount,
        error: output.error ? exports.transformError(output.error) : null
    };
};
exports.transformAffordabilityOutputToResult = function (output) {
    return {
        propertyValue: output.propertyValue,
        loanPercent: output.loanPercent,
        monthlyPayment: output.monthlyPayment,
        loanAmount: output.loanAmount,
        assumedInterestRate: output.assumedInterestRate,
        totalExpenses: output.totalExpenses,
        totalCashOutlay: output.totalCashOutlay,
        totalInterest: output.totalInterest,
        totalTax: output.totalTax,
        commission: output.commission,
        downPayment: output.downPayment,
        schedule: output.schedule,
        rateTable: output.rateTable,
        insurance: output.insurance,
        insuranceInitial: output.insuranceInitial,
        legalAmount: output.legalAmount,
        isInsuranceMonthlyRepay: output.isInsuranceMonthlyRepay,
        error: output.error ? exports.transformError(output.error) : null,
    };
};
exports.transformRefinanaceOutputToResult = function (output, input) {
    return {
        cashOut: output.cashout,
        newMonthlyPayment: output.newMonthlyRepayment,
        newTotalInterest: output.newTotalInterest,
        existingMonthlyPayment: output.existingMonthlyRepayment,
        existingTotalInterest: output.existingTotalInterest,
    };
};
